<template>
    <div class="dashboard-production h-100 text-center">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading" />
        </transition>
        <template v-if="errors">
            <ErrorsZone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors">
            <div class="d-flex flex-row dashboard-row">
                <div class="row no-gutters flex-fill">
                    <div class="col-3 p-3 border border-black text-white">
                        <div class="h1 mb-0">
                            {{ todayHumanDate }}
                            <small>{{ currentHumanHour }}</small>
                        </div>
                    </div>
                    <div class="col-9 p-3 border border-black text-white">
                        <div class="h1 mb-0">
                            <span>
                                Fabrication
                                {{category.name}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <alerts type="dashboards"></alerts>
            <div v-if="!productionSlipProducts[categoryId]" class="d-flex flex-row dashboard-row">
                <div class="row no-gutters flex-fill">
                    <div class="p-3 border border-black col-12 preparation-bg-cyan">
                        <div class="h2 mb-0 text-ellipsis">
                            Aucune fabrication attendue pour cette catégorie
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex flex-row dashboard-row">
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-left h5">
                        Produits
                    </div>
                </div>
                <div class="flex-fill">
                    <template v-for="(categoryProducts, categoryId) in productionSlipProducts[categoryId].products">
                        <div class="row no-gutters flex-fill">
                            <template v-for="(preparationCounters, typePreparation) in categoryProducts">
                                <template v-for="(preparationProductCounters, sku) in preparationCounters.products">
                                    <div class="p-3 border border-black col-2 preparation-bg-cyan">
                                        <div class="p-1 pb-0">
                                            <div class="h2 mb-0 text-ellipsis">
                                                {{ preparationProductCounters.product.tiny_name }}
                                            </div>
                                            <div class="huge-number">{{ preparationProductCounters.quantity }}</div>
                                        </div>
                                        <div class="row no-gutters flex-fill">
                                            <div class="col-3 py-1 line-height-1 border border-black text-white bg-dark">
                                                <div class="h4 mb-0">
                                                {{ preparationProductCounters.quantity_pickup_point }}
                                                </div>
                                                Lieu<br />retrait
                                            </div>
                                            <div class="col-6 py-1 line-height-1 border border-black text-white bg-dark">
                                                <div class="h2 mb-0">
                                                {{ preparationProductCounters.quantity_prioritised }}
                                                </div>
                                                Avant 16h
                                            </div>
                                            <div class="col-3 py-1 line-height-1 border border-black text-white bg-dark">
                                                <div class="h4 mb-0">
                                                    {{ preparationProductCounters.quantity_not_prioritised }}
                                                </div>
                                                Après<br />16h
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                </div>
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-right h5">
                        Produits
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import ErrorsZone from "../../ErrorsZone";
    import LoadingScreen from "../../LoadingScreen";
    import DashboardOrderBox from "./DashboardOrderBox";
    import {useGetLoader} from "../../compositions/axios/loadingRequest";
    import {moment, momentDay} from "../../../moment-with-helpers";
    import {preparationBgClass} from "../../../preparation-classes";

    export default {
        name: "DashboardProduction",

        components: {
            ErrorsZone,
            LoadingScreen,
            DashboardOrderBox,
        },

        props: {
            screenUid: {
                type: String,
                required: true,
            },
            screen: {
                type: Object,
                required: false,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                currentHumanHour: '',
                loadedOnce: false,
                productionSlipProducts: {},
                category: {},
            };
        },

        created() {
            Echo.channel(`dashboards`).listen('OrderUpdatedEvent', (e) => {
                this.loadStateFromServer();
            });
        },

        async mounted() {
            this.updateCurrentHumanHour()
            setInterval(this.updateCurrentHumanHour.bind(this) , 1000)

            await this.loadStateFromServer();
        },

        computed: {
            preparationBgClass,

            todayJsDate() {
                return momentDay()
            },
            todayDate() {
                return this.todayJsDate.format('YYYY-MM-DD')
            },
            todayHumanDate() {
                return this.todayJsDate.format('dddd Do MMMM')
            },
            categoryId() {
                let categoryId = 0;
                if(this.screen.options && this.screen.options.categoryId) {
                    categoryId = this.screen.options.categoryId;
                }
                return categoryId;
            }
        },

        methods: {
            updateCurrentHumanHour: function() {
                this.currentHumanHour = moment().format('HH:mm:ss')
            },
            loadStateFromServer: async function () {
                const data = await this.load(`/dashboards/production/${this.todayDate}/categorie/${this.categoryId}/json`);
                if (data) {
                    this.productionSlipProducts = data.productionSlipProducts;
                    this.category = data.category;
                    this.loadedOnce = true;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .dashboard-production {
        background-color: #343a40;

        .dashboard-row {
            background-color: #343a40;
            border-bottom: 4px solid #000;
            min-height: 110px;
        }

        .sidebars {
            width: 70px;
            position: relative;
            line-height: 1;
            .rotate {
                font-size: 1.125rem;
                line-height: 1;
            }
        }

        .line-height-1 {
            line-height: 1;
        }

        .huge-number {
            font-size: 2.75rem;
        }
    }
</style>
